import { ITextProps, ITooltipHostProps, Stack, Text, TooltipHost } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { useMemo } from 'react';

export const SubHeader = ({ subHeader: { name } }: { subHeader: { name: string } }) => {
    const id = useId('sub-header');
    const tooltipContent = useMemo(() => {
        switch (name) {
            case 'Allocation':
                return 'Allocation on the contract';
            case 'Free':
                return 'Free capacity';
            case 'Request':
            default:
                return 'Request on the contract';
        }
    }, [name]);
    return (
		<Stack className={name}>
			<TooltipHost content={tooltipContent} styles={tooltipHostStyles}>
				<Text id={id} styles={textStyles}>
					{name}
				</Text>
			</TooltipHost>
		</Stack>
    );
};

const tooltipHostStyles: ITooltipHostProps['styles'] = {
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'end',
        paddingRight: 8,
    },
};

const textStyles: ITextProps['styles'] = {
    root: {
        fontWeight: 600,
    },
};
